<form [formGroup]="form" class="row">
    <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Modelo do documento</mat-label>
            <mat-select formControlName="tiposNota" multiple>
                @for (tipo of listaModeloDocumento; track tipo.idModeloDocumento) {
                <mat-option [value]="tipo.idModeloDocumento">{{ tipo.nome }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Destinatário (Empresas)</mat-label>
            <mat-select formControlName="listIdEmpresa" multiple>
                <mat-select-trigger>
                    {{ selectedCompaniesText }}
                </mat-select-trigger>
                @for (empresa of listaEmpresas; track empresa.idEmpresa) {
                <mat-option [value]="empresa.idEmpresa">
                    <div class="d-flex align-items-center">
                        <span>{{ empresa.nomeEmpresa }} | {{empresa.cnpj}}</span>
                    </div>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Pesquisar (Nota, Emitente...)</mat-label>
            <input matInput formControlName="pesquisar" placeholder="Termo de pesquisa">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Série</mat-label>
            <input matInput type="text" formControlName="serie" mask="000" [validation]="false" inputmode="numeric" maxlength="3" />
        </mat-form-field>
    </div>

    <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>CFOP</mat-label>
            <input matInput type="text" formControlName="cfop" [mask]="masks.cfop" [validation]="false" inputmode="numeric" />
                    <button mat-icon-button matSuffix type="button" class="icon-mat-symbols-btn"
                        aria-label="Pesquisar CFOP" [disabled]="form.get('cfop')?.disabled"
                        (click)="$event.stopPropagation(); pesquisarCfop()">
                        <mat-icon>search</mat-icon>
                    </button>
        </mat-form-field>
    </div>
</form>
